<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_10"></a><a id="ch2"></a>A Test of the Emergency<br/>Alert System</h3>
<p class="noindent">Directions:</p>
<p class="noindent"><em>To the best of your ability, please answer the following questions</em>.</p>
<p class="numbert">1.) Which of the following is not currently found in my bathtub?</p>
<p class="numbera"> a.) My wife</p>
<p class="numbera"> b.) My dog</p>
<p class="numbera"> c.) My unborn child</p>
<p class="numbera"> d.) Tornado</p>
<p class="number">2.) Which of the following activities are best performed while enduring a disaster in your bathtub?</p>
<p class="numbera"> a.) Secret sharing</p>
<p class="numbera"> b.) Secret keeping</p>
<p class="numbera"> c.) Dog petting</p>
<p class="numbera"> d.) Scrubbing the tub</p>
<p class="numbera"> e.) All of the above</p>
<p class="number"><a id="page_11"></a>3.) Which of the following is the proper response in the immediate aftermath of a disaster?</p>
<p class="numbera"> a.) Calling family</p>
<p class="numbera"> b.) Calling friends</p>
<p class="numbera"> c.) Waiting for the cell phone signal</p>
<p class="numbera"> d.) Continuing to wait for the cell phone signal</p>
<p class="numbera"> e.) Leashing your dog</p>
<p class="numbera"> f.) Unleashing your dog</p>
<p class="numbera"> g.) Introducing yourself to God</p>
<p class="numbera"> h.) Introducing God to your wife and dog and unborn child</p>
<p class="numbera">  i.) Living up to your part of the bargain</p>
<p class="numbera">  j.) Exiting your house</p>
<p class="numbera"> k.) Wondering how your plant didn’t tip</p>
<p class="numbera">  l.) Drinking a beer</p>
<p class="numbera">m.) Drinking two beers</p>
<p class="numbera"> n.) Drinking zero beers and remembering your part of the bargain</p>
<p class="numbera"> o.) Drinking four beers and remembering your part of the bargain</p>
<p class="numbera"> p.) Pouring your beer in the sink</p>
<p class="numbera"> q.) In the grass</p>
<p class="numbera"> r.) In the plant that didn’t tip</p>
<p class="numbera"> s.) Telling your wife the words that got stuck in your throat in that bathtub</p>
<p class="numbera"> t.) Writing your wife a note—it’ll last longer</p>
<p class="numbera"> u.) Taking a photo—it’ll last longer</p>
<p class="numbera"> v.) Crumbling that note, that photo, and cracking that beer instead</p>
<p class="numbera">w.) Unleashing yourself to God</p>
<p class="numbera"> x.) All of the above</p>
<p class="numbera"><a id="page_12"></a> y.) Some of the above</p>
<p class="numbera"> z.) None</p>
<p class="number">4.) True or False: You were just a little scared.</p>
<p class="number">5.) Which of the following newspaper quotations has been fabricated?</p>
<p class="numbera"> a.) “We saw it spinning across the street . . .”</p>
<p class="numbera"> b.) “I was standing at the door and saw it coming.”</p>
<p class="numbera"> c.) “. . . I looked out the window and saw it hovering over the lake . . .”</p>
<p class="numbera"> d.) “I was just trying to get my grandkids something to eat.”</p>
<p class="numbera"> e.) “It just sat there too. Like it was chilling.”</p>
<p class="numbera"> f.) “I have a shell of a home; just four walls.”</p>
<p class="numbera"> g.) “I pulled two dead bodies from a . . .”</p>
<p class="numbera"> h.) “I found an elderly lady and a three-year-old . . .”</p>
<p class="numbera">  i.) “People laid blankets over the bodies of neighbors . . .”</p>
<p class="numbera">  j.) “First responders didn’t attend to the dead.”</p>
<p class="numbera"> k.) “It happened too fast to be scared.”</p>
<p class="numbera">  l.) “This just can’t be true.”</p>
<p class="numbera">m.) None</p>
<p class="number">6.) Which of the following tools most effectively removes debris?</p>
<p class="numbera"> a.) Chainsaw</p>
<p class="numbera"> b.) Axe</p>
<p class="numbera"> c.) Bow saw</p>
<p class="numbera"> d.) Poem</p>
<p class="number">7.) Where is the silver lining?</p>
<p class="number">8.) In what ways did your students respond to your attempts to contact them?</p>
<p class="numbera"> a.) With kind assurances of his safety</p>
<p class="numbera"><a id="page_13"></a> b.) With concern for your safety</p>
<p class="numbera"> c.) By writing you a poem</p>
<p class="numbera"> d.) By writing you an email</p>
<p class="numbera"> e.) By asking you for her final grade</p>
<p class="numbera"> f.) By thanking you for an “awesome” semester</p>
<p class="numbera"> g.) By wishing you the best of luck in your new job</p>
<p class="numbera"> h.) By wishing you no ill will (despite the B–)</p>
<p class="numbera">  i.) By apologizing for the late paper—“The tornado ate it.”</p>
<p class="numbera">  j.) By asking for extra credit</p>
<p class="numbera"> k.) By asking “pretty please” for extra credit</p>
<p class="numbera">  l.) By asking you for your story</p>
<p class="numbera">m.) By asking you what she’s supposed to do now</p>
<p class="numbera"> n.) By asking you “Where is the silver lining?”</p>
<p class="numbera"> o.) By asking you if he’ll seriously never see you again</p>
<p class="numbera"> p.) By telling you she’ll Facebook you</p>
<p class="numbera"> q.) By telling you that composition class taught him little of survival</p>
<p class="numbera"> r.) By telling you that African American literature taught him little of survival</p>
<p class="numbera"> s.) By writing “The nightmares won’t quit coming, will they?”</p>
<p class="numbera">  t.) By writing “TTYL”</p>
<p class="numbera"> u.) By writing</p>
<p class="numbera"> v.) By not writing</p>
<p class="numbera">w.) With silence</p>
<p class="numbera"> x.) All of the above</p>
<p class="numbera"> y.) Some of the above</p>
<p class="numbera"> z.) None</p>
<p class="number"><a id="page_14"></a>9.) In the space below, please draw a picture of anything but this.</p>
<p class="noindent1"><em>Essay:</em></p>
<p class="indent">In the space below, please write whatever you must. You can understand, I’m sure, the necessity of writing, even in the dark. Of re-inhabiting a space you’d just as soon forget. I’m asking you not to forget. I’m asking you to remember. To recall the relief you felt in waking up the morning after. And the frustration you felt while mummy-wrapped in the sweat-soaked sheets. Please take a moment to remember the way your foot crunched the cockroach on your walk to the bathroom that night.</p>
<p class="indent">Consider the loss of life and all you didn’t lose. All you had to lose. All you might’ve lost had the wind recalculated its route.</p>
<p class="indent">Consider infrastructure, pregnancy tests.</p>
<p class="indent">Reconsider question #4.</p>
<p class="indent">Please, I’m begging you; do not provide specific examples in the space provided below.</p>
<p class="imagea"><a id="page_15"></a><img alt="image" src="images/f0015-01.jpg"/></p>
<p class="imagea"><a id="page_16"></a><img alt="image" src="images/f0016-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?c099aada